export const formatPhone = (phone) => {

    var cleaned = ('' + phone).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '1-' + match[1] + '-' + match[2] + '-' + match[3];
    }
    return null;
}

export const unFormatPhone = (phone) => {
   let parsedPhone = phone.replace(/-/g, "").replace(/\s/g, "").replace(/[{()}]/g, "");
   if(parsedPhone.length == 10){
       return parsedPhone;
   }

   parsedPhone = parsedPhone.substring(1, parsedPhone.length);

   return parsedPhone;
}